import { render, staticRenderFns } from "./publicheader.vue?vue&type=template&id=2e37cff2"
import script from "./publicheader.vue?vue&type=script&lang=js"
export * from "./publicheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports